//SERVER ROUTES
export const USER_SERVER = '/api/v1';

/**
 * Returns the base URL for API calls based on the current environment
 * - In development: returns empty string (uses proxy)
 * - In production: returns the appropriate URL based on hostname
 */
export const getEnvironmentBaseUrl = () => {
  if (process.env.NODE_ENV === 'development') {
    return ''; // Empty for local development (uses proxy)
  }
  
  // Check the current hostname
  const hostname = window.location.hostname;
  if (hostname === 'flow-test.ubuck.org') {
    return 'https://flow-test.ubuck.org';
  }
  if (hostname === 'flow.ubuck.org') {
    return 'https://flow.ubuck.org';
  }
  
  // Fallback (shouldn't happen, but just in case)
  console.warn('[Flow-Frontend] Unknown environment:', hostname);
  return '';
};

/**
 * Returns the base URL for authentication endpoints
 * This is separate from the API URL because auth might be on a different path
 */
export const getAuthBaseUrl = () => {
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:8080'; // Direct URL to backend in development
  }
  
  // In production, use the same base URL
  return getEnvironmentBaseUrl();
};

/**
 * Returns the full API URL by combining the base URL with the API path
 */
export const getApiUrl = (path) => {
  const baseUrl = getEnvironmentBaseUrl();
  return `${baseUrl}${path}`;
};
